export const PREVIEW_LIMIT = 5;
export const ALL_ITEMS_PAGE_SIZE = 10;
export const CELLPHONE_LENGTH = 10;

const CELLPHONE_DIGITS = new RegExp(`^\\d{0,${CELLPHONE_LENGTH}}$`);

const toTimestamp = (createdDate) => {
    if (Array.isArray(createdDate)) {
        const [year, month = 1, day = 1, hour = 0, minute = 0, second = 0] = createdDate;
        return new Date(year, month - 1, day, hour, minute, second).getTime();
    }
    const timestamp = createdDate ? new Date(createdDate).getTime() : 0;
    return Number.isNaN(timestamp) ? 0 : timestamp;
};

export const sortByNewest = (items) =>
    [...items].sort((first, second) => toTimestamp(second.createdDate) - toTimestamp(first.createdDate));

export const isCellphoneInput = (value) => CELLPHONE_DIGITS.test(value);

export const isCompleteCellphone = (value) => (value ?? "").length === CELLPHONE_LENGTH;

const COUNTRY_CODE = "57";

export const toLocalCellphone = (cellphone) => {
    const digits = `${cellphone ?? ""}`;
    const hasCountryCode = digits.length === COUNTRY_CODE.length + CELLPHONE_LENGTH && digits.startsWith(COUNTRY_CODE);
    return hasCountryCode ? digits.slice(COUNTRY_CODE.length) : digits;
};

export const formatCellphone = (cellphone) => {
    const digits = toLocalCellphone(cellphone);
    if (digits.length !== CELLPHONE_LENGTH) {
        return digits;
    }
    return `${digits.slice(0, 3)} ${digits.slice(3, 6)} ${digits.slice(6)}`;
};

const normalizeText = (text) =>
    `${text ?? ""}`
        .normalize("NFD")
        .replace(/[̀-ͯ]/g, "")
        .toLowerCase();

export const matchesSearch = (fields, searchTerm) => {
    const term = normalizeText(searchTerm).trim();
    if (!term) {
        return true;
    }
    return fields.some((field) => normalizeText(field).includes(term));
};

export const getSedeLabel = (sede) =>
    [sede?.name || sede?.address, sede?.city].filter(Boolean).join(" - ");

export const toSede = (storeCommerce) => ({
    uuid: storeCommerce.uuid,
    name: storeCommerce.name || "",
    address: storeCommerce.address || "",
    city: storeCommerce.city || "",
    department: storeCommerce.department || "",
    cellphone: storeCommerce.cellphone || "",
    createdDate: storeCommerce.createdDate,
});

export const toCellphone = (commerceCellphone) => ({
    uuid: commerceCellphone.uuid || commerceCellphone.id || null,
    number: toLocalCellphone(commerceCellphone.cellphone || commerceCellphone.number || commerceCellphone),
    createdDate: commerceCellphone.createdDate,
});

export const toAsesor = (advisor) => ({
    uuid: advisor.uuid || advisor.id || null,
    name: advisor.name || "",
    lastName: advisor.lastName || "",
    documentNumber: advisor.documentNumber || "",
    email: advisor.email || "",
    isActive: advisor.isActive ?? true,
    storeCommerceUuid: advisor.storeCommerce?.uuid || "",
    commerceCellphoneUuid: advisor.commerceCellphone?.uuid || "",
    sedeLabel: getSedeLabel(advisor.storeCommerce),
    cellphoneLabel: toLocalCellphone(advisor.commerceCellphone?.cellphone),
    createdDate: advisor.createdDate,
});
